import {API_URL, APP_NAME} from '@/config';
import {GetAccessTokenUseCase} from '@/domain/useCases/auth/getAccessTokenUseCase';
import {GetCurrentUserUseCase} from '@/domain/useCases/auth/getCurrentUserUseCase';
import {IsTokenValidUseCase} from '@/domain/useCases/auth/isTokenValidUseCase';
import {LoginUseCase} from '@/domain/useCases/auth/loginUseCase';
import {LogoutUseCase} from '@/domain/useCases/auth/logoutUseCase';
import {CreateSlamPointCloudsUseCase} from '@/domain/useCases/createSlamPointCloudsUseCase';
import {CreateUavPointCloudsUseCase} from '@/domain/useCases/createUavPointCloudsUseCase';
import {DeleteSlamPointCloudsUseCase} from '@/domain/useCases/deleteSlamPointCloudsUseCase';
import {DeleteUavPointCloudsUseCase} from '@/domain/useCases/deleteUavPointCloudsUseCase';
import {DownloadGpkgForestMassUseCase} from '@/domain/useCases/downloadGpkgForestMassUseCase';
import {DownloadPointCloudsUseCase} from '@/domain/useCases/downloadPointCloudsUseCase';
import {GetAllAppraisersUseCase} from '@/domain/useCases/getAllAppraisersUseCase';
import {GetAllForestMassStatusesUseCase} from '@/domain/useCases/getAllForestMassStatusesUseCase';
import {GetAllForestMassUseCase} from '@/domain/useCases/getAllForestMassUseCase';
import {GetAllInventoryPlotsByForestMassUuidUseCase} from '@/domain/useCases/getAllInventoryPlotsByForestMassUuidUseCase';
import {GetAllLidarTechnoligiesUseCase} from '@/domain/useCases/getAllLidarTechnoligiesUseCase';
import {GetAllSpeciesUseCase} from '@/domain/useCases/getAllSpeciesUseCase';
import {GetForestMassByForestMassSpeciesUuid} from '@/domain/useCases/getForestMassByForestMassSpeciesUuid';
import {GetForestMassByUuidUseCase} from '@/domain/useCases/getForestMassByUuidUseCase';
import {GetForestMassSpeciesByForestMassUuidUseCase} from '@/domain/useCases/getForestMassSpeciesByForestMassUuidUseCase';
import {GetForestMassSpeciesBySpecieUuidUseCase} from '@/domain/useCases/getForestMassSpeciesBySpecieUuidUseCase';
import {GetInventoryPlotByUuidUseCase} from '@/domain/useCases/getInventoryPlotByUuidUseCase';
import {GetInventoryStemsByInventoryPlotUuidUseCase} from '@/domain/useCases/getInventoryStemsByInventoryPlotUuidUseCase';
import {GetSlamPointCloudsByInventoryPlotUuidUseCase} from '@/domain/useCases/getSlamPointCloudsByInventoryPlotUuidUseCase';
import {GetUavPointCloudsByForestMassUuidUseCase} from '@/domain/useCases/getUavPointCloudsByForestMassUuidUseCase';
import {OpCreateInventoryPlot} from '@/domain/useCases/opCreateInventoryPlot';
import {OpCutForestMassUseCase} from '@/domain/useCases/opCutForestMassUseCase';
import {OpUploadForestMassUseCase} from '@/domain/useCases/opUploadForestMassUseCase';
import {OpWeightIntentoryPlots} from '@/domain/useCases/opWeightIntentoryPlots';
import {PublishErrorUseCase} from '@/domain/useCases/PublishErrorUseCase';
import {ReUploadPointCloudsUseCase} from '@/domain/useCases/reUploadPointCloudsUseCase';
import {SubscribeToErrorsUseCase} from '@/domain/useCases/SubscribeToErrorsUseCase';
import {UpdateForestMassSpeciesUseCase} from '@/domain/useCases/updateForestMassSpeciesUseCase';
import {UpdateForestMassUseCase} from '@/domain/useCases/updateForestMassUseCase';
import {GpkgHttpClient} from '@/infrastructure/implementations/HttpClient/gpkgHttpClient';
import {JsonHttpClient} from '@/infrastructure/implementations/HttpClient/jsonHttpClient';
import {MultipartHttpClient} from '@/infrastructure/implementations/HttpClient/multipartHttpClient';
import {RestAppraiserRepository} from '@/infrastructure/repositories/appraiser/AppraiserRepository';
import {RestForestMassRepository} from '@/infrastructure/repositories/forestMass/ForestMassRepository';
import {RestForestMassSpeciesRepository} from '@/infrastructure/repositories/forestMassSpecies/ForestMassSpeciesRepository';
import {RestForestMassStatusRepository} from '@/infrastructure/repositories/forestMassStatus/ForestMassStatusRepository';
import {RestInventoryPlotRepository} from '@/infrastructure/repositories/inventoryPLot/InventoryPLotRepository';
import {RestInventoryStemRepository} from '@/infrastructure/repositories/inventoryStem/InventoryStemRepository';
import {RestLidarTechnologyRepository} from '@/infrastructure/repositories/lidarTechnology/LidarTechnologyRepository';
import {RestOpRepository} from '@/infrastructure/repositories/op/OpRepository';
import {RestSlamPointCloudRepository} from '@/infrastructure/repositories/slamPointCloud/SlamPointCloudRepository';
import {RestSpecieRepository} from '@/infrastructure/repositories/specie/SpecieRepository';
import {RestUavPointCloudRepository} from '@/infrastructure/repositories/uavPointCloud/UavPointCloudRepository';
import {RestAuthService} from '@/infrastructure/services/AuthService';
import {ErrorServiceImpl} from '@/infrastructure/services/ErrorServiceImpl';
import {LocalStorageAccessTokenService} from '@/infrastructure/services/LocalStorageAccessTokenService';

const ACCESS_TOKEN_KEY = `${APP_NAME}.accessToken`;

export const accessTokenService = new LocalStorageAccessTokenService(ACCESS_TOKEN_KEY);

// Services
const errorService = new ErrorServiceImpl();
const jsonHttpClientWithLogin = new JsonHttpClient(API_URL, accessTokenService.get);
const gpkgHttpClientWithLogin = new GpkgHttpClient(API_URL, accessTokenService.get);
const multipartHttpClientWithLogin = new MultipartHttpClient(API_URL, accessTokenService.get);
// Repositories
const appraiserRepository = new RestAppraiserRepository(jsonHttpClientWithLogin);
const forestMassRepository = new RestForestMassRepository(jsonHttpClientWithLogin, gpkgHttpClientWithLogin);
const forestMassStatusesRepository = new RestForestMassStatusRepository(jsonHttpClientWithLogin);
const specieRepository = new RestSpecieRepository(jsonHttpClientWithLogin);
const forestMassSpeciesRepository = new RestForestMassSpeciesRepository(jsonHttpClientWithLogin);
const opRepository = new RestOpRepository(jsonHttpClientWithLogin, multipartHttpClientWithLogin);
export const authRepository = new RestAuthService(jsonHttpClientWithLogin);
const lidarTechnologiesRepository = new RestLidarTechnologyRepository(jsonHttpClientWithLogin);
const uavPointCloudsRepository = new RestUavPointCloudRepository(jsonHttpClientWithLogin, multipartHttpClientWithLogin);
const inventoryPlotRepository = new RestInventoryPlotRepository(jsonHttpClientWithLogin);
const inventoryStemRepository = new RestInventoryStemRepository(jsonHttpClientWithLogin);
const slamPointCloudsRepository = new RestSlamPointCloudRepository(
  jsonHttpClientWithLogin,
  multipartHttpClientWithLogin,
);

// UseCases
export const getAllAppraisersUseCase = new GetAllAppraisersUseCase(appraiserRepository);
export const getAllForestMassUseCase = new GetAllForestMassUseCase(forestMassRepository);
export const getForestMassByUuidUseCase = new GetForestMassByUuidUseCase(forestMassRepository);
export const getForestMassByForestMassSpeciesUuid = new GetForestMassByForestMassSpeciesUuid(
  forestMassRepository,
  forestMassSpeciesRepository,
);
export const updateForestMassUseCase = new UpdateForestMassUseCase(forestMassRepository);
export const downloadGpkgForestMassUseCase = new DownloadGpkgForestMassUseCase(forestMassRepository);
export const getAllForestMassStatusesUseCase = new GetAllForestMassStatusesUseCase(forestMassStatusesRepository);
export const getAllSpeciesUseCase = new GetAllSpeciesUseCase(specieRepository);
export const getForestMassSpeciesByForestMassUuidUseCase = new GetForestMassSpeciesByForestMassUuidUseCase(
  forestMassSpeciesRepository,
);
export const getForestMassSpeciesBySpecieUuidUseCase = new GetForestMassSpeciesBySpecieUuidUseCase(
  forestMassSpeciesRepository,
);
export const updateForestMassSpeciesUseCase = new UpdateForestMassSpeciesUseCase(forestMassSpeciesRepository);
export const opCutForestMassUseCase = new OpCutForestMassUseCase(
  opRepository,
  forestMassRepository,
  forestMassStatusesRepository,
);
export const opUploadForestMassUseCase = new OpUploadForestMassUseCase(opRepository);
export const opCreateInventoryPlot = new OpCreateInventoryPlot(opRepository);
export const opWeightIntentoryPlotsUseCase = new OpWeightIntentoryPlots(opRepository);
export const loginUseCase = new LoginUseCase(accessTokenService, authRepository);
export const logoutUseCase = new LogoutUseCase(accessTokenService);
export const getAccessTokenUseCase = new GetAccessTokenUseCase(accessTokenService);
export const isTokenValidUseCase = new IsTokenValidUseCase(accessTokenService);
export const getCurrentUserUseCase = new GetCurrentUserUseCase(authRepository);
export const getAllLidarTechnologiesUseCase = new GetAllLidarTechnoligiesUseCase(lidarTechnologiesRepository);
export const createUavPointCloudsUseCase = new CreateUavPointCloudsUseCase(uavPointCloudsRepository);
export const deleteUavPointCloudsUseCase = new DeleteUavPointCloudsUseCase(uavPointCloudsRepository);
export const getUavPointCloudsByForestMassUuidUseCase = new GetUavPointCloudsByForestMassUuidUseCase(
  uavPointCloudsRepository,
);
export const publishErrorUseCase = new PublishErrorUseCase(errorService);
export const subscribeToErrorsUseCase = new SubscribeToErrorsUseCase(errorService);
export const getAllInventoryPlotsByForestMassUuidUseCase = new GetAllInventoryPlotsByForestMassUuidUseCase(
  inventoryPlotRepository,
);
export const getInventoryPlotByUuidUseCase = new GetInventoryPlotByUuidUseCase(inventoryPlotRepository);
export const getInventoryStemsByInventoryPlotUuidUseCase = new GetInventoryStemsByInventoryPlotUuidUseCase(
  inventoryStemRepository,
);

export const getSlamPointCloudsByInventoryPlotUuidUseCase = new GetSlamPointCloudsByInventoryPlotUuidUseCase(
  slamPointCloudsRepository,
);
export const createSlamPointCloudsUseCase = new CreateSlamPointCloudsUseCase(slamPointCloudsRepository);
export const deleteSlamPointCloudsUseCase = new DeleteSlamPointCloudsUseCase(slamPointCloudsRepository);
export const downloadUavPointCloud = new DownloadPointCloudsUseCase(uavPointCloudsRepository);
export const downloadSlamPointCloud = new DownloadPointCloudsUseCase(slamPointCloudsRepository);
export const reUploadUavPointCloud = new ReUploadPointCloudsUseCase(uavPointCloudsRepository);
export const reUploadSlamPointCloud = new ReUploadPointCloudsUseCase(slamPointCloudsRepository);
